/**
 * Use this filter to convert a timestamp to a moment formatted string
 *
 * Usage Example
 *
 *  Formats a timestamp to a format like 2013-06-24:
 *
 *      <div>{{ timestamp | moment:'YYYY-MM-DD' }}</div>
 */
define('common/ko/filters/moment',['knockout', 'underscore', 'moment', 'knockout.punches'], function (ko, _, moment) {

    ko.filters.moment = function (timestamp, format) {

        return ko.computed(function () {

            var unwrapped = ko.unwrap(timestamp);

            if (!unwrapped) {
                return '';
            }

            return moment(unwrapped).format(format);

        });
    };

});

